<script setup>
  import { useI18n } from 'vue-i18n';
  import AdvancedSearchCriteria from '../advanced_search/AdvancedSearchCriteria.vue';

  // The other props (the criteria options and initial values) go through to the criteria
  defineOptions({ inheritAttrs: false });

  const { t } = useI18n();

  defineProps({
    badge: { type: String, default: '1' },
    nextStepTarget: { type: String, default: '#step_1' },
    parentId: { type: String, default: '#carousel_wizard' },
    initiallyOpen: { type: Boolean, default: false }
  });
</script>

<template>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button" :class="{ collapsed: !initiallyOpen }" type="button" data-bs-toggle="collapse" data-bs-target="#metadata_step" :aria-expanded="initiallyOpen" aria-controls="metadata_step">
        <span class="badge bg-secondary me-2">{{ badge }}</span>
        {{ t('scheduled_cart_filters.metadata_step_title') }}
      </button>
    </h2>
    <div id="metadata_step" class="accordion-collapse collapse" :class="{ show: initiallyOpen }" :data-bs-parent="parentId">
      <div class="accordion-body">
        <AdvancedSearchCriteria v-bind="$attrs" input_name="search_criteria" />

        <div class="row mt-3">
          <div class="col d-flex justify-content-end">
            <button
              type="button"
              class="btn mkt-btn-primary"
              data-bs-toggle="collapse"
              :data-bs-target="nextStepTarget"
              aria-expanded="false"
            >
              {{ t('scheduled_cart_filters.next_step') }}<i class="bi bi-arrow-right ms-1" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="../../locales/en.json" global></i18n>
<i18n src="../../locales/fr.json" global></i18n>
<i18n src="../../locales/es.json" global></i18n>
<i18n src="../../locales/it.json" global></i18n>
<i18n src="../../locales/pt.json" global></i18n>
<i18n src="../../locales/de.json" global></i18n>
